import { useState, useEffect } from "react";
import apiClient from "../api/client";

// Fallback if API is unreachable
const FALLBACK_STOCKS = [
  { symbol: "DLEKG.TA", name: "דלק" },
  { symbol: "NWMD.TA", name: "ניו מד" },
  { symbol: "MEDN.TA", name: "מהדרין" },
  { symbol: "ITH.LSE", name: "איתקה" },
  { symbol: "ISCD.TA", name: "ישראכרט" },
  { symbol: "AP-UN.TO", name: "Allied" },
];

let cachedStocks = null;
let cachePromise = null;

function fetchTrackedStocks() {
  if (cachedStocks) return Promise.resolve(cachedStocks);
  if (cachePromise) return cachePromise;
  cachePromise = apiClient
    .get("/api/rates/tracked-stocks")
    .then((res) => {
      cachedStocks = res.data;
      cachePromise = null;
      return cachedStocks;
    })
    .catch(() => {
      cachePromise = null;
      return FALLBACK_STOCKS;
    });
  return cachePromise;
}

/** Invalidate the cache so next call re-fetches from API */
export function invalidateTrackedStocksCache() {
  cachedStocks = null;
  cachePromise = null;
}

/** Hook that returns { stocks, loading } from the tracked-stocks API */
export function useTrackedStocks() {
  const [stocks, setStocks] = useState(cachedStocks || []);
  const [loading, setLoading] = useState(!cachedStocks);

  useEffect(() => {
    let cancelled = false;
    fetchTrackedStocks().then((data) => {
      if (!cancelled) {
        setStocks(data);
        setLoading(false);
      }
    });
    return () => { cancelled = true; };
  }, []);

  return { stocks, loading };
}
